var map = {
	"./Alex.png": 75256,
	"./Blaze.png": 5319,
	"./Creeper.png": 81811,
	"./Enderman.png": 19285,
	"./Skeleton.png": 78590,
	"./Steve.png": 72631,
	"./Wither_Skeleton.png": 65308,
	"./Zombie.png": 20466
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15189;